import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Lineup from './components/Lineup';
import IntroductionPlan from './components/IntroductionPlan';
import HowToUse from './components/HowToUse';
import Kiln from './components/Kiln';
import Venues from './components/Venues';
import Distributor from './components/Distributor';
import Location from './components/Location';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <Hero />
      <About />
      <Features />
      <Lineup />
      <IntroductionPlan />
      <HowToUse />
      <Kiln />
      <Venues />
      <Distributor />
      <Contact />
      <Location />
      <Footer />
    </div>
  );
}
